/**
 * 监听事件
 */
class EventListener {
  private eventMap: Map<string, Array<(...args: any[]) => void>>;

  constructor() {
    this.eventMap = new Map();
  }
  /**
   * 监听事件
   * @param {string} key
   * @param {Function} cb
   */
  on(key: string, cb: (...args: any[]) => void) {
    let handlers = this.eventMap.get(key);
    if (!handlers) {
      handlers = [];
    }
    handlers.push(cb);
    this.eventMap.set(key, handlers);
  }

  /**
   * 移除监听事件
   * @param {string} key
   * @param {Function} cb
   */
  off(key: string, cb?: (...args: any[]) => void) {
    const handlers = this.eventMap.get(key);
    if (!handlers) return;
    if (cb) {
      const idx = handlers.indexOf(cb);
      idx > -1 && handlers.splice(idx, 1);
      this.eventMap.set(key, handlers);
    } else {
      this.eventMap.delete(key);
    }
  }
  /**
   * 只监听一次事件
   * @param {string} key
   * @param {Function} cb
   */
  once(key: string, cb: (...args: any[]) => void) {
    const handlers = [
      (payload: any) => {
        cb(payload);
        this.off(key);
      },
    ];
    this.eventMap.set(key, handlers);
  }
  /**
   * 触发事件
   * @param {string} key
   * @param {any} payload
   */
  emit(key: string, payload?: any) {
    const handlers = this.eventMap.get(key);
    if (!Array.isArray(handlers)) return;
    handlers.forEach((handler) => {
      handler(payload);
    });
  }
}

const listener = new EventListener();

export default listener;
